module.exports = __webpack_public_path__ + "7e7a62f7ebce9767203fddac75427596.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-32.png
// module id = 2508
// module chunks = 0